module.exports = __webpack_public_path__ + "img/dextools.3f81d15e.png";